import { apiSlice } from './apiSlice';
const LEAGUES_URL = '/api/leagues';

export const leaguesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchLeagues: builder.query({
      query: (leagueId) => leagueId ? `${LEAGUES_URL}/${leagueId}` : `${LEAGUES_URL}`,
      providesTags: ['Leagues'],    // Tags the data for cache management
    }),
    fetchAvailableLeagues: builder.query({
      query: (userId) => `${LEAGUES_URL}/available/${userId}`,
      providesTags: ['Leagues'],
    }),
    addLeague: builder.mutation({
      query: (newLeague) => ({
        url: `${LEAGUES_URL}`,
        method: 'POST',
        body: newLeague,
      }),
      invalidatesTags: ['Leagues'], // Invalidates 'Leagues' tag to refetch data
    }),
    joinLeague: builder.mutation({
      query: ({ leagueId, privateJoinToken }) => ({
        url: `${LEAGUES_URL}/${leagueId}/join`,
        method: 'POST',
        body: privateJoinToken ? { privateJoinToken } : {},
      }),
      invalidatesTags: ['Leagues', 'Athletes', 'Team'],
    }),
    updateLeague: builder.mutation({
      query: (league) => ({
        url: `${LEAGUES_URL}/${league.id}`,
        method: 'PUT',
        body: league,
      }),
      invalidatesTags: ['Leagues'], // Refetches leagues on update
    }),
    deleteLeague: builder.mutation({
      query: (leagueId) => ({
        url: `${LEAGUES_URL}/${leagueId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Leagues'], // Refetches leagues on deletion
    }),
    removeLeagueMember: builder.mutation({
      query: ({ leagueId, athleteId }) => ({
        url: `${LEAGUES_URL}/${leagueId}/members/${athleteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Leagues'],
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the endpoints
export const {
  useFetchLeaguesQuery,
  useFetchAvailableLeaguesQuery,
  useAddLeagueMutation,
  useJoinLeagueMutation,
  useUpdateLeagueMutation,
  useDeleteLeagueMutation,
  useRemoveLeagueMemberMutation,
} = leaguesApiSlice;
